"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DRepAlwaysNoConfidence = void 0;
var cbor_1 = require("@harmoniclabs/cbor");
var roDescr_1 = require("../../utils/roDescr.js");
var DRepType_1 = require("./DRepType.js");
var defaultToDataVersion_1 = require("../../toData/defaultToDataVersion.js");
var plutus_data_1 = require("@harmoniclabs/plutus-data");
var DRepAlwaysNoConfidence = /** @class */ (function () {
    function DRepAlwaysNoConfidence(_info) {
        Object.defineProperties(this, {
            drepType: __assign({ value: DRepType_1.DRepType.AlwaysNoConfidence }, roDescr_1.roDescr),
            hash: __assign({ value: undefined }, roDescr_1.roDescr) // to preserve shape
        });
    }
    DRepAlwaysNoConfidence.prototype.toData = function (version) {
        version = (0, defaultToDataVersion_1.definitelyToDataVersion)(version);
        if (version === "v1" || version === "v2")
            throw new Error("DRep not supported before v3");
        return new plutus_data_1.DataConstr(2, // PDrep.AlwaysNoConfidence
        []);
    };
    DRepAlwaysNoConfidence.prototype.toCbor = function () {
        return cbor_1.Cbor.encode(this.toCborObj());
    };
    DRepAlwaysNoConfidence.prototype.toCborObj = function () {
        return new cbor_1.CborArray([
            new cbor_1.CborUInt(this.drepType)
        ]);
    };
    DRepAlwaysNoConfidence.prototype.toJson = function () {
        return {
            drepType: (0, DRepType_1.drepTypeToString)(this.drepType)
        };
    };
    return DRepAlwaysNoConfidence;
}());
exports.DRepAlwaysNoConfidence = DRepAlwaysNoConfidence;
